<p *ngIf="displayString != ''" style="font-size: 2rem;">{{displayString}}</p>
